import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { Ribbon24Regular, LockOpen24Regular, DesignIdeas24Regular } from "@fluentui/react-icons";
import RouterApp from "./Router/RouterApp";
import { HashRouter } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
  const styles = useStyles();
  
 

  return (
    <div className={styles.root}>
       <HashRouter>
           <RouterApp/>
            </HashRouter>
    </div>
  );
};

export default App;
